export type RecoveryRedirect = {
  pathname: '/reset-password'
  search: string
  hash: string
}

/**
 * Password-recovery links from Supabase often land on Site URL (/)
 * with tokens in the hash or `token_hash` query. Route gates must not
 * steal those tokens before /reset-password can establish a session.
 */
export function recoveryRedirectTarget (
  pathname: string,
  hash: string,
  search: string
): RecoveryRedirect | null {
  if (pathname === '/reset-password') return null

  const rawHash = hash.startsWith('#') ? hash.slice(1) : hash
  const rawSearch = search.startsWith('?') ? search.slice(1) : search
  const hashParams = new URLSearchParams(rawHash)
  const query = new URLSearchParams(rawSearch)

  const type = hashParams.get('type') || query.get('type')
  const hasTokenHash = Boolean(query.get('token_hash') || hashParams.get('token_hash'))
  const isRecovery = type === 'recovery' || (hasTokenHash && !type)

  if (!isRecovery) return null

  return {
    pathname: '/reset-password',
    search: rawSearch ? `?${rawSearch}` : '',
    hash: rawHash ? `#${rawHash}` : '',
  }
}

/** Relative href for a full-page replace before React/Supabase boot. */
export function recoveryRedirectHref (
  pathname: string,
  hash: string,
  search: string
): string | null {
  const to = recoveryRedirectTarget(pathname, hash, search)
  if (!to) return null
  return `${to.pathname}${to.search}${to.hash}`
}
